/*
 * Which "I am" option the contact form should open on, given where the reader
 * came from.
 *
 * Carried as a query param rather than router state or document.referrer.
 * Router state is lost on refresh and unavailable to a link pasted into an
 * email; referrer is empty on same-app navigation and unreliable everywhere
 * else. A param survives a cold load, works from outside the app, and can be
 * checked without opening a browser.
 *
 * /contact strips the param from the URL once it has read it, so the prefilled
 * variants are never shared or indexed as separate URLs.
 *
 * Default is 'employer'. Employers are the ICP, and the calculator that shares
 * this page is written for them.
 */

export const DEFAULT_WHO = 'employer';

// Longest prefix wins, so /solutions/... style paths cannot match the wrong row.
const ROUTES = [
    ['/individuals', 'individual'],
    ['/getstarted', 'individual'],
    ['/steadystride', 'individual'],
    ['/physiotherapists', 'physio'],
    ['/researchers', 'researcher'],
    ['/employers', 'employer'],
];

export function whoFromPath(pathname) {
    if (!pathname) return DEFAULT_WHO;
    const p = pathname.toLowerCase();
    const hit = ROUTES.find(([prefix]) => p === prefix || p.startsWith(prefix + '/'));
    return hit ? hit[1] : DEFAULT_WHO;
}

/* The header's Contact us link, which appears on every page: it should carry
   the page the reader is currently on rather than always saying employer.
   No hash handling on purpose — nothing links to /contact#something, and a
   query string has to precede the fragment, which is easy to get wrong. */
export function contactHref(pathname) {
    return `/contact?who=${whoFromPath(pathname)}`;
}

export function readWho(search) {
    const m = /[?&]who=([a-z]+)/i.exec(search || '');
    const v = m && m[1].toLowerCase();
    return ['employer', 'individual', 'physio', 'researcher', 'other'].includes(v)
        ? v
        : DEFAULT_WHO;
}
